type DateTimePickerProps = {
  className?: string;
  label: string;
  dateTime: string;
  setDateTime: (v: string) => void;
  disabled?: boolean;
};
const DateTimePicker = ({ className = "", label, dateTime, setDateTime, disabled = false }: DateTimePickerProps) => {
  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event: React.ChangeEvent<HTMLInputElement>) =>
    setDateTime(event.target.value);

  return (
    <div className={`flex items-stretch rounded-lg border border-gray-300 ${className}`}>
      <style>
        {`
    input[type="date"]::-webkit-calendar-picker-indicator,
    input[type="datetime-local"]::-webkit-calendar-picker-indicator {
      display: none;
    }
  `}
      </style>
      <div
        className={`flex shrink-0 items-center border-r border-gray-300 rounded-l-lg bg-gray-100 px-3 py-2 text-xs font-semibold text-gray-700 cursor-default ${
          disabled ? "opacity-25" : ""
        }`}
      >
        {label}
      </div>
      <div className="z-10 flex grow">
        <input
          className="flex grow border-transparent placeholder:text-gray-300 focus:border-primary-500 focus:ring-primary-500 disabled:bg-gray-50 disabled:text-gray-600 disabled:opacity-25 sm:text-sm"
          type="datetime-local"
          id="id"
          name="id"
          value={dateTime}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div
        className={`flex shrink-0 items-center border-l border-gray-300 rounded-r-lg bg-gray-100 px-3 py-2 text-xs font-semibold text-gray-700 cursor-default ${
          disabled ? "opacity-25" : ""
        }`}
      >
        UTC
      </div>
    </div>
  );
};

export default DateTimePicker;
